module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-pencil-278451424d184d4cfcd7f465ce5ab657.png";